<template>
  <Modal
    :dialog="dialog_params_delete.show"
    :dialog_params="dialog_params_delete"
  >
    <template #body>
      <v-form>
        <h3>{{ dialog_params_delete.text }}</h3>
      </v-form>
    </template>

    <template #buttons>
      <v-btn
        color="#EB6363"
        dark
        @click="
          dialog_params_delete.callback(dialog_params_delete.id);
          dialog_params_delete.show = false;
        "
        >Excluir</v-btn
      >
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Layout/Modal";

export default {
  components: {
    Modal,
  },
  name: "DeleteModal",
  props: {
    modal_data_delete: { type: Object },
    dialog_params_delete: {
      type: Object,
      default: { title: "Modal", size: "80%", text: "Remover?", show: false },
    },
  },
};
</script>

<style scoped>
.v-input__slot {
  cursor: text;
  background-color: #ffffff !important;
}
.v-text-field__details {
  display: none !important;
}
</style>
